import React from "react";
import { Link } from "react-router-dom";

const AboutTeaser = ({ t, lang, data }) => {
    return (
        <section className="py-5 bg-card">
            <div className="container">
                <div className="row align-items-center py-5 gy-5">
                    <div className="col-lg-6 order-lg-2" data-aos="zoom-in">
                        <h2 className="fw-bold mb-4">
                            {lang === "en" ? "Who We Are" : "من نحن"}
                        </h2>

                        <p className="mb-4">
                            {t("home_about_desc")}
                        </p>

                        <div className="row g-4 mb-4">
                            <div className="col-6">
                                <div className="d-flex align-items-center gap-3">
                                    <div className="bg-primary text-dark p-2 rounded-circle">
                                        <i className="ri-trophy-line fs-4"></i>
                                    </div>
                                    <div>
                                        <h5 className="mb-0 fw-bold">10+</h5>
                                        <small className="text-muted">
                                            {lang === "en" ? "Years Experience" : "سنوات خبرة"}
                                        </small>
                                    </div>
                                </div>
                            </div>

                            <div className="col-6">
                                <div className="d-flex align-items-center gap-3">
                                    <div className="bg-primary text-dark p-2 rounded-circle">
                                        <i className="ri-user-smile-line fs-4"></i>
                                    </div>
                                    <div>
                                        <h5 className="mb-0 fw-bold">200+</h5>
                                        <small className="text-muted">
                                            {lang === "en" ? "Happy Clients" : "عملاء سعداء"}
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <Link to="/about" className="btn btn-outline-custom">
                            {t("home_about_btn")}
                        </Link>
                    </div>

                    <div className="col-lg-6 order-lg-1">
                        <div className="row g-3">
                            <div className="col-6" data-aos="zoom-in">
                                <img
                                    src="https://images.unsplash.com/photo-1552664730-d307ca884978"
                                    className="img-fluid rounded-custom shadow-sm"
                                    alt="Office"
                                />
                            </div>

                            <div className="col-6 mt-5" data-aos="fade-up">
                                <img
                                    src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf"
                                    className="img-fluid rounded-custom shadow-sm"
                                    alt="Meeting"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutTeaser;